module.exports = __webpack_public_path__ + "img/hr-tree-06-g-trunk.51048166.png";